<template>
  <main class="pricing container">
    <section class="pricing__top">
      <div
          :style="{'--bg-url': `url(
              ${getImageFromProxy(siteHost + '/img/pricing-gradient.png', '820:500')}
              )`}
            "
          class="pricing__hero"
      >
        <p class="pricing__gradient-text pricing__subtitle-gradient">
          {{ t('choose_plan_now') }}
        </p>
        <h1 class="pricing__title">
          {{ t('unlock_more_feat') }}
        </h1>
        <p class="pricing__hero-desc">
          {{ t('enhance_your_experience') }}
        </p>
      </div>

      <div class="pricing__subscriptions-time">
        <div id="pricing__tumbler" class="pricing__tumbler">
          <button
              :class="{'btn-violet': period === PlanDurationType.Monthly}"
              class="btn btn-primary fw500"
              @click="period = PlanDurationType.Monthly"
          >
            {{ t('monthly') }}
          </button>
          <button
              :class="{'btn-violet': period === PlanDurationType.Annually}"
              class="btn btn-primary fw500"
              @click="period = PlanDurationType.Annually"
          >
            {{ t('annualy') }}
          </button>
        </div>
        <!--        <p class="time__desc">-->
        <i18n-t :tag="'p'" class="time__desc" keypath="save_with_subscription">
          <template #save>
            <span>{{ t('save_text', {value: '8.2'}) }}</span>
          </template>
        </i18n-t>
        <!--          <span>Save 8.2%</span> with annualy subscription-->
        <!--        </p>-->
      </div>

      <PlansList :period="period" @choosePlan="choosePlan" />
    </section>

    <section class="pricing__our-plans">
      <div class="section__header">
        <div class="section__header-lside">
          <h2 class="pricing__h2-title">
            {{ t('compare_our_plans') }}
          </h2>
          <p>
            {{ t('compare_our_plans_desc') }}
          </p>
        </div>
        <div class="section__header-rside pricing__tumbler">
          <button
              :class="{'btn-violet': period === PlanDurationType.Monthly}"
              class="btn fw500 btn-primary"
              @click="period = PlanDurationType.Monthly"
          >
            {{ t('pay_monthly') }}
          </button>
          <button
              :class="{'btn-violet': period === PlanDurationType.Annually}"
              class="btn fw500 btn-primary"
              @click="period = PlanDurationType.Annually"
          >
            {{ t('pay_annualy') }}
          </button>
        </div>
      </div>
      <div class="our-plans__body">
        <PagesPricingComparePlanItem />
        <PagesPricingComparePlanItem
            :info="PLANS[UserPlan.Standard]"
            :period="period"
            :plan="UserPlan.Standard"
            @choosePlan="choosePlan"
        />
        <PagesPricingComparePlanItem
            :info="PLANS[UserPlan.Pro]"
            :period="period"
            :plan="UserPlan.Pro"
            @choosePlan="choosePlan"
        />
        <PagesPricingComparePlanItem
            :info="PLANS[UserPlan.Business]"
            :period="period"
            :plan="UserPlan.Business"
            @choosePlan="choosePlan"
        />
      </div>
    </section>

    <section class="pricing__addons">
      <div class="section__header">
        <div class="section__header-lside">
          <h2 class="pricing__h2-title">
            {{ t('our_popular_services') }}
          </h2>
          <p>
            {{ t('our_popular_services_desc') }}
          </p>
        </div>
        <nuxt-link
            :to="localePath('/profile/services')"
            class="btn fw500 btn-primary gap8 mobile-hide"
        >
          <svg height="20" width="20">
            <use xlink:href="/icons/sprite.svg#i-bag"></use>
          </svg>
          {{ t('discover_all_services') }}
        </nuxt-link>
      </div>
      <div class="addons__body">
        <PagesPricingAddonsCard
            v-for="(addon, key) in filteredServices"
            :key="key"
            :info="addon"
            :props-key="key"
        />
      </div>
    </section>

    <section
        :style="{'--bg-url': `url(
                    ${getImageFromProxy(siteHost + '/img/pricing-gradient.png', '820:500')}
                    )`}
                  "
        class="pricing__contact"
    >
      <div class="contact__wrapper">
        <div class="contact__header">
          <div class="contact__header-lside">
            <i18n-t class="contact__title" keypath="plans_suit" tag="h2">
              <template #everyone>
                <span class="pricing__gradient-text">{{ t('everyone') }}!</span>
              </template>
            </i18n-t>

            <p class="contact__subtitle">
              {{ t('plans_suit_desc') }}
            </p>
          </div>
          <div class="contact__header-rside">
            <a
                class="btn btn-primary btn-gradient-violet fw500"
                href="https://t.me/csmcadmin"
                rel="noopener noreferrer nofollow"
                target="_blank"
            >
              <svg height="20" width="20">
                <use xlink:href="/icons/sprite.svg#i-support"></use>
              </svg>
              {{ t('contact_sales_team') }}
            </a>
          </div>
        </div>
        <div class="contact__body">
          <div class="contact__body-row">
            <div class="contact__body-item">
              <span>{{ t('market_price_tracking') }}</span>
            </div>
            <div class="contact__body-item">
              <span>{{ t('price_change_analysis') }}</span>
            </div>
            <div class="contact__body-item">
              <span>{{ t('multi_game_support') }}</span>
            </div>
            <div class="contact__body-item">
            </div>
            <div class="contact__body-item">
            </div>
            <div class="contact__body-item">
            </div>
            <div class="contact__body-item">
            </div>
          </div>
          <div class="contact__body-row">
            <div class="contact__body-item">
              <span>{{ t('best_price_recommendations') }}</span>
            </div>
            <div class="contact__body-item">
              <span>{{ t('personalized_alerts') }}</span>
            </div>
            <div class="contact__body-item">
              <span>{{ t('demand_supply') }}</span>
            </div>
            <div class="contact__body-item">
            </div>
            <div class="contact__body-item">
            </div>
            <div class="contact__body-item">
            </div>
            <div class="contact__body-item">
            </div>
          </div>
        </div>
        <a
            class="btn-contact btn btn-primary btn-gradient-violet fw500"
            href="https://t.me/csmcadmin"
            rel="noopener noreferrer nofollow"
            target="_blank"
        >
          <svg height="20" width="20">
            <use xlink:href="/icons/sprite.svg#i-support"></use>
          </svg>
          {{ t('contact_sales_team') }}
        </a>
      </div>
    </section>

    <section class="pricing__qa">
      <h2 class="pricing__h2-title tac mb56">
        {{ t('what_ask_about_plans') }}
      </h2>

      <PagesMarketComponentsQuestionsHub
          v-if="faq?.length"
          :items="faq"
          hide-title
      />
    </section>
  </main>
</template>

<script lang="ts" setup>
import {PlanDurationType, SelectUserPlan, UserPlan} from "~/graphql/generated/schema-types";
import {useStore} from "~/store";
import {cancelPlan, selectPlan} from "~/utils/api";
import {useModalStore} from "~/store/modal";
import {ModalIds} from "~/types/Modals";
import PlansList from "~/components/Pages/Pricing/PlansList.vue";
import {PLANS} from "~/data/plans";
import {AddonInfoLocal, ADDONS} from "~/data/addons";
import {computed} from "vue";

// const LazyComponent = defineAsyncComponent({
//   loader: () => import('~/components/Pages/Pricing/AddonsCard.vue'),
//   hydrate: hydrateOnVisible()
// });
// new nuxt lazy import

definePageMeta({
  layout: 'no-categories',
})

const config = useRuntimeConfig();
const siteHost = config.public.siteHost;

const {t} = useI18n();
const localePath = useLocalePath()
const faq = computed(() => {
  const items: { name: string; value: string; }[] = [];
  Array.from({length: 5}, (_, i) => i + 1).map((i) => {
    items.push({
      name: t(`pricing_faq.faq_${i}_title`),
      value: t(`pricing_faq.faq_${i}_desc`).replaceAll('- ', '<br>'),
    });
  });
  return items;
});

const filteredServices = computed(() => {
  return Object.keys(ADDONS).reduce((acc, curr) => {
    if (!ADDONS[curr as keyof typeof ADDONS].isAddon) {
      acc[curr] = ADDONS[curr as keyof typeof ADDONS]
    }
    return acc
  }, {} as Record<string, AddonInfoLocal>)
})

const store = useStore()
const {openModal} = useModalStore()

// const {data} = await useAsyncData('getUserAddons', () => getUserAddons())
// store.userAddons = data?.value?.data?.myAddons?.result || []

const period = ref<PlanDurationType>(PlanDurationType.Monthly)

function isSelectUserPlan(value: any): value is SelectUserPlan {
  return Object.values(SelectUserPlan).includes(value);
}

const choosePlan = async (plan: UserPlan) => {
  if (!store.user) {
    EventBus.$emit('notify', {
      success: false,
      msg: t('you_need_logged')
    })
    return
  }
  if (!isSelectUserPlan(plan)) {
    console.log('Invalid plan')
    return
  }

  if (!store.user) {
    EventBus.$emit('notify', {
      success: false,
      msg: t('you_need_logged')
    })
  }

  if (store.user?.plan === plan) {
    EventBus.$emit('notify', {
      success: false,
      msg: t('you_already_plan')
    })
    return
  }
  if (store.user?.plan !== UserPlan.Free) {
    openModal(ModalIds.UPGRADE_PLAN, {
      toPlan: plan,
      fromPlan: store.user?.plan || UserPlan.Free,
      unusedRequests: store.user?.api_request_left
    }, {
      onConfirm: (afterCurrentPlan: boolean) => {
        console.log(afterCurrentPlan, `asdasdas`)
        openModal(ModalIds.PAYMENT_METHOD, {
          plan: plan,
          duration: period.value,
          afterCurrentPlan
        })
      }
    })
    return
  }

  openModal(ModalIds.PAYMENT_METHOD, {
    plan: plan,
    duration: period.value,
    afterCurrentPlan: false
  })
}

const cancelAndChangePlan = async (plan: SelectUserPlan) => {
  try {
    const {data, errors} = await cancelPlan()
    if (errors?.length || !data) {
      throw new Error(errors?.[0]?.message || t('failed_to_cancel_plan'))
    }
    try {
      const {data: data2, errors: errors2} = await selectPlan(plan, period.value)
      if (errors2?.length || !data2) {
        throw new Error(errors?.[0]?.message || t('failed_to_select_plan'))
      }

      window.location.href = data2.selectPlan
    } catch (e: any) {
      throw new Error(e.message)
    }
  } catch (e: any) {
    EventBus.$emit('notify', {
      success: false,
      msg: e.message
    })
  }
}
</script>

<style lang="scss" scoped>
.pricing {
  color: var(--surfaces-on-surface-variable);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  position: relative;
  z-index: 1;

  section {
    margin-bottom: 160px;
  }

  .btn-gradient-violet {
    border-radius: 10px;
    background: linear-gradient(90deg, #FF59C8 0%, #725DF8 100%);
    transition: all 0.3s ease;
    color: #FFFFFF;
    white-space: nowrap;
    gap: 8px;
    height: 44px;

    &:hover {
      background: linear-gradient(90deg, #FF59C8 0%, #FF59C8 20%, #725DF8 100%);
    }
  }

  &__h2-title {
    color: var(--surfaces-on-surface);
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px; /* 133.333% */
  }

  &__top {
    padding-top: 250px;
    background: var(--bg-url);
    //background: url("/img/pricing-gradient.png");
    background-size: 100% auto;
    background-position: center 15%;
    background-repeat: no-repeat;
  }

  &__hero {
    max-width: 820px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    position: relative;

    &-desc {
      max-width: 480px;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px; /* 200% */
    }

    //&:after {
    //  content: '';
    //  position: absolute;
    //  z-index: -1;
    //  inset: -40%;
    //  background: var(--bg-url);
    //  background-size: contain;
    //  background-position: center;
    //  background-repeat: no-repeat;
    //  max-width: 100vw;
    //}
  }

  &__gradient-text {
    background: linear-gradient(90deg, #FF59C8 34.23%, #725DF8 65.28%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &__subtitle-gradient {
    text-align: center;
    font-kerning: none;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px; /* 180% */
    text-transform: uppercase;
  }

  &__title {
    color: var(--surfaces-on-surface);
    text-align: center;
    font-kerning: none;
    font-size: 55px;
    font-style: normal;
    font-weight: 700;
    line-height: 65px; /* 118.182% */
    text-transform: uppercase;
  }

  .pricing__tumbler {
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: var(--surfaces-low-container);

    .btn {
      height: 44px;
    }
  }

  &__subscriptions-time {
    margin: 56px 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    .time__desc {
      color: var(--surfaces-on-surface-variable);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;

      span {
        color: var(--accent-on-surface)
      }
    }
  }

  &__plans {
    display: flex;
    gap: 32px;
    align-items: flex-end;
    justify-content: center;
    margin: 0 auto;
    max-width: 1024px;
  }

  .section__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
    margin: 0 auto 56px;

    &-lside {
      display: flex;
      flex-direction: column;
      gap: 18px;
      max-width: 570px;
    }
  }

  &__our-plans {
    .our-plans {
      &__body {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 16px;
      }
    }
  }

  &__addons {
    .addons__body {
      display: grid;
      //grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 16px;
    }
  }

  &__contact {
    background: var(--bg-url);
    //background: url("/img/pricing-gradient.png");
    background-size: 110% auto;
    background-position: center 15%;
    background-repeat: no-repeat;

    .btn-contact {
      display: none;
    }

    .contact {
      &__wrapper {
        position: relative;
        width: 100%;
        max-width: 900px;
        margin: 0 auto;
        overflow: hidden;
        padding: 85px 70px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 44px;
        border-radius: 28px;
        background: rgba(22, 26, 35, 0.70);
      }

      &__title {
        color: var(--surfaces-on-surface);
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px; /* 133.333% */
      }

      &__subtitle {
        max-width: 360px;
      }

      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 32px;
        margin: 0 auto 56px;

        &-lside {
          display: flex;
          flex-direction: column;
          gap: 18px;
        }
      }

      &__body {
        display: flex;
        flex-direction: column;
        gap: 13px;

        &-item {
          border-radius: 10px;
          min-width: 160px;
          background: var(--surfaces-high-container);
          padding: 11px 16px;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          white-space: nowrap;
        }

        &-row {
          display: flex;
          gap: 8px;
        }
      }
    }
  }

  @media screen and (max-width: 979px) {
    section {
      margin-bottom: 100px;
    }
    .mobile-hide {
      display: none;
    }
    &__h2-title {
      font-size: 24px;
      line-height: 32px;
    }
    .section__header {
      margin: 0 auto 32px;
    }
    .section__header-lside {
      gap: 16px;
    }

    &__top {
      padding-top: 100px;
      background-size: 150%;
      background-position: center 0;
      background-repeat: no-repeat;
      margin-left: -16px;
      margin-right: -16px;
      padding-right: 16px;
      padding-left: 16px;
    }

    &__hero {
      gap: 20px;

      &-desc {
        font-size: 14px;
        font-weight: 400;
        line-height: 24px
      }
    }

    &__subtitle-gradient {
      text-align: center;
      font-size: 16px;
    }

    &__title {
      font-size: 44px;
      line-height: 52px; /* 118.182% */
    }

    .pricing__tumbler .btn {
      height: 40px;
    }

    &__subscriptions-time {
      margin-top: 32px;
    }
    &__our-plans {
      display: none;
    }
    &__contact {
      background-size: 150% auto;

      .btn-contact {
        display: flex;
        align-self: center;
        width: 100%;
        max-width: 360px;
      }

      .contact {
        &__wrapper {
          padding: 32px 24px;
          gap: 24px;
        }

        &__title {
          text-align: center;
          font-size: 20px;
          line-height: 28px; /* 133.333% */
        }

        &__subtitle {
          text-align: center;
          max-width: 360px;
        }

        &__header {
          justify-content: center;
          gap: 16px;
          margin: 0 auto;

          &-lside {
            gap: 16px;
          }

          &-rside {
            display: none;
          }
        }

        &__body {
          gap: 8px;

          &-item {
            font-size: 12px;
            font-weight: 400;
            min-width: 140px;
          }

          &-row {
            display: flex;
            gap: 8px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .pricing__contact .contact__body {
      margin-left: -100px;
    }
  }
}
</style>
